var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionViewport } from "./actionViewport";
var initial = {
    zoomRequested: false,
};
export var reducerViewport = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionViewport.ClearCenter:
        case TypeActionViewport.CenterOn:
            return __assign({}, state, { centerPosition: action.position, zoomRequested: action.zoom });
        case TypeActionViewport.SmoothZoom:
            return __assign({}, state, { zoomRequested: true });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/reducerViewport.ts
// module id = 2985
// module chunks = 3